import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: 'O QUE É A SELEÇÃO DE MODELOS E ATORES?',
    answer:
      'A Seleção de Modelos e Atores é uma Entrevista avaliativa do perfil e talento dos candidatos. Não há desfile, não é necessário decorar texto e nem apresentar book fotográfico.',
  },
  {
    question: 'O QUE ACONTECE NA SELEÇÃO?',
    answer:
      'Antes da Avaliação os candidatos e seus responsáveis participam de uma palestra com a diretora da agência onde será explicado toda a metodologia, etapas e procedimentos. Serão informados os desafios da carreira, casos de sucesso e também o investimento necessário para participar das próximas etapas.\n\nApós a palestra, os candidatos são encaminhados para avaliação, onde terão a oportunidade de se apresentar e contar um pouco sobre suas experiências e objetivos com a carreira.\n\nO resultado da avaliação é divulgado na hora.',
  },
  {
    question: 'COMO SE PREPARAR PARA A SELEÇÃO?',
    answer:
      'A Seleção tem por objetivo avaliar o perfil e aptidão dos candidatos e identificar NOVOS TALENTOS para o mundo da Moda e Televisão, por isso, é sempre bom ir o mais natural possível e demonstrar suas características reais. É importante manter a calma e se apresentar de maneira confiante, sabendo o motivo de estar na seleção.',
  },
  {
    question: 'MENOR DE IDADE PRECISA IR ACOMPANHADO?',
    answer:
      'SIM. Para participar da Seleção, o candidato que for menor de idade precisa estar acompanhado de um maior de idade responsável. Caso os pais não possam acompanhá-lo, o candidato poderá ir com outro responsável, desde que haja o consentimento dos pais.',
  },
  {
    question: 'COMO DEVO IR À SELEÇÃO?',
    answer:
      'Para ir à seleção, o candidato deve usar roupas confortáveis e básicas. As meninas podem estar com o cabelo preso ou solto e natural, com pouca ou nenhuma maquiagem. O uso de acessórios, maquiagem em excesso ou qualquer forma de cobrir as características reais podem interferir negativamente na avaliação.',
  },
];

function FAQCard({ item, defaultOpen = false }: { item: FAQItem; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className="rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer"
      style={{
        border: open ? '1px solid rgba(234,179,8,0.5)' : '1px solid rgba(234,179,8,0.18)',
        background: open
          ? 'linear-gradient(145deg, rgba(234,179,8,0.07) 0%, #0f0f0f 100%)'
          : 'linear-gradient(145deg, #111111, #0a0a0a)',
      }}
      onClick={() => setOpen(prev => !prev)}
    >
      {/* Header */}
      <div className="flex items-center justify-between gap-4 px-5 py-4 sm:px-6 sm:py-5">
        <p
          className="text-sm sm:text-base font-black leading-snug"
          style={{
            fontFamily: 'Montserrat, sans-serif',
            color: open ? '#EAB308' : '#FFFFFF',
            transition: 'color 0.3s',
          }}
        >
          {item.question}
        </p>
        <div
          className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300"
          style={{
            background: open ? 'linear-gradient(135deg, #EAB308, #CA8A04)' : 'rgba(234,179,8,0.1)',
            transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
          }}
        >
          <i className="ri-add-line text-sm" style={{ color: open ? '#000' : '#EAB308' }} />
        </div>
      </div>

      {/* Body */}
      <div
        style={{
          maxHeight: open ? '600px' : '0px',
          overflow: 'hidden',
          transition: 'max-height 0.45s ease',
        }}
      >
        <div
          style={{ height: '1px', background: 'rgba(234,179,8,0.15)' }}
        />
        <div className="px-5 py-4 sm:px-6 sm:py-5">
          {item.answer.split('\n\n').map((para, i) => (
            <p
              key={i}
              className={`text-sm leading-relaxed ${i > 0 ? 'mt-3' : ''}`}
              style={{ color: '#9CA3AF', fontFamily: 'Montserrat, sans-serif', fontWeight: 300 }}
            >
              {para}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function FAQSection() {
  return (
    <section className="px-4 sm:px-5 pb-10">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-7">
          <p
            className="text-xs font-bold uppercase tracking-widest mb-2"
            style={{ color: '#EAB308', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.22em' }}
          >
            Tire suas dúvidas
          </p>
          <h2
            className="text-xl sm:text-2xl md:text-3xl font-black text-white leading-tight"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Tudo que você precisa saber{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #EAB308, #FDE68A)' }}
            >
              antes de vir
            </span>
          </h2>
        </div>

        {/* FAQ List */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <FAQCard key={faq.question} item={faq} defaultOpen={i === 0} />
          ))}
        </div>
      </div>
    </section>
  );
}
